<template>
  <div v-loading="loading" class="alarmClass">
    <div>
      <el-form :model="form" ref="formRef" :rules="formRules" label-suffix=":" label-width="105px">
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="车场名称" prop="parkingLotId">
              <el-select
                v-model="form.parkingLotId"
                disabled
                style="width:100%"
                placeholder="请选择所属车场"
                @change="spaceIdChange"
              >
                <el-option
                  v-for="item in spaceIdList"
                  :key="item.id"
                  :label="item.title"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="车场区域" prop="regionIds">
              <avue-input-tree
                :check-strictly="true"
                multiple
                :disabled="model == 'view'"
                style="width: 100%;"
                v-model="form.regionIds"
                placeholder="请选择车场区域"
                :props="regionProps"
                :dic="regionList"
              ></avue-input-tree>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="车牌号" prop="plateNumber">
              <el-input
                clearable
                :disabled="model == 'view'"
                v-model="form.plateNumber"
                placeholder="请输入车牌号"
                maxlength="8"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="车主姓名" prop="driverName">
              <el-input
                clearable
                :disabled="model == 'view'"
                v-model="form.driverName"
                placeholder="请输入车主姓名"
                maxlength="32"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="车主电话" prop="mobile">
              <el-input
                clearable
                :disabled="model == 'view'"
                v-model="form.mobile"
                placeholder="请输入车主电话"
                maxlength="15"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="单位信息" prop="companyName">
              <el-input
                clearable
                :disabled="model == 'view'"
                v-model="form.companyName"
                placeholder="请输入单位信息"
                maxlength="32"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="开始时间" prop="startDate">
              <el-date-picker
                :disabled="model == 'view'"
                v-model="form.startDate"
                type="date"
                format="yyyy-MM-dd"
                valueFormat="yyyy-MM-dd 00:00:00"
                placeholder="选择开始时间"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="结束时间" prop="endDate">
              <el-date-picker
                v-model="form.endDate"
                :disabled="model == 'view'"
                type="date"
                format="yyyy-MM-dd"
                valueFormat="yyyy-MM-dd 23:59:59"
                placeholder="选择开始时间"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="类型" prop="blackType">
              <el-select
                :disabled="model == 'view'"
                v-model="form.blackType"
                style="width:100%"
                placeholder="请选择类型"
              >
                <el-option
                  v-for="item in typeList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="form.blackType==0">
            <el-form-item label="授权类型" prop="parkAreaRightType">
              <el-select
                v-model="form.parkAreaRightType"
                :disabled="model == 'view'"
                style="width:100%"
                placeholder="请选择类型"
              >
                <el-option
                  v-for="item in parkAreaRightTypeList"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="备注" prop="remark">
              <el-input
                :disabled="model == 'view'"
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 4 }"
                placeholder="请输入备注"
                v-model="form.remark"
                maxlength="200"
                show-word-limit
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="图片" prop="businessLicenseFileUrlList">
                <!-- <el-upload
                class="avatar-uploader"
                accept=".jpg,.jpeg,.png"
                action="/api/v4ward/oss/customEndpoint/put-file"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :http-request="httpRequest"
                :before-upload="beforeAvatarUpload">
                <img v-if="form.imgUrl" :src="form.imgUrl" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
               
                </el-upload> -->
                <vUpload :imageUrl.sync="form.imgUrl"></vUpload>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      
    </div>
    <div style="    text-align: right;" v-if="model != 'view'">
      <el-button type="primary" icon="el-icon-circle-plus-outline" @click="saveRecord" size="small">
        {{ model == 'add' ? '提交' : '修改' }}
      </el-button>
      <el-button icon="el-icon-circle-close" @click="cancleRecord" size="small">
        取消
      </el-button>
    </div>
  </div>
</template>
<script>
import { getDictionary } from '@/api/common.js';
import { getParkList, nodeTreeByParentId } from './index.js';
import {
  add,
  getDetail,
  getList,
  remove,
  update,
  syncBlacklist,
  delayBlacklist,
  submitImportFile,
} from '@/api/v4ward/park/blacklistv2/parkblacklist';
import { putFile, downloadFile } from '@/api/crmedical/contract/add';
import vUpload from './imageUrlupload.vue';
export default {
  components: { vUpload },
  props: {
    row: {
      default: {},
    },
    spaceId: {},
    type: {},
    model: {
      default: 'add',
    },
  },
  data() {
    return {
        imageUrl:'',
        searchForm:{
            code:''
        },
        propsHttp: {
              res: 'data',
              name: 'originalName',
              url: 'link',
            },
      regionList: [],
      regionProps: {
        label: 'title',
        value: 'id',
      },
      typeList: [
        { label: '白名单', value: 0 },
        { label: '黑名单', value: 1 },
      ],
      spaceIdList: [],
      parkAreaRightTypeList: [],
      form: {
        imgUrl:'',
        parkingLotId: '',
        regionIds: '',
        plateNumber: '',
        driverName: '',
        mobile: '',
        companyName: '',
        startDate: '',
        endDate: '',
        blackType: '',
        parkAreaRightType: '0',
        remark: '',
      },
      formRules: {
        parkingLotId: [{ required: true, message: '车场名称不能为空', trigger: 'blur' }],
        regionIds: [{ required: true, message: '车场区域不能为空', trigger: 'change' }],
        plateNumber: [
          { required: true, message: '车牌号不能为空', trigger: 'blur' },
          { pattern: this.$validation.carPlate, message: '车牌格式不对', trigger: 'blur' },
        ],
        driverName: [{ required: true, message: '车主姓名不能为空', trigger: 'blur' }],
        mobile: [
          { required: true, message: '车主电话不能为空', trigger: 'blur' },
          { pattern: this.$validation.phone, message: '请输入正确的手机号', trigger: 'blur' },
        ],
        companyName: [{ required: false, message: '单位信息不能为空', trigger: 'blur' }],
        startDate: [{ required: true, message: '开始时间不能为空', trigger: 'change' }],
        endDate: [{ required: true, message: '结束时间不能为空', trigger: 'change' }],
        blackType: [{ required: true, message: '类型不能为空', trigger: 'change' }],
        parkAreaRightType: [{ required: true, message: '授权类型不能为空', trigger: 'change' }],
      },
      dataList: [
        {
          code: {
            code: '012023082200000002',
            planVersion: 'V2',
          },
          status: 1,
          msg: '查找不到数据',
        },
      ],
    };
  },
  created() {
    this.initData();
    console.log('---',JSON.stringify(this.dataList[0].code))
  },
  mounted() {},
  watch: {},
  methods: {
    beforeAvatarUpload(file) {
        const isJPG = file.type === 'image/jpeg'||file.type === 'image/png';
        const isLt2M = file.size / 1024 / 1024 < 5;

        if (!isJPG) {
          this.$message.error('上传头像图片只能是 JPG /png格式!');
        }
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 5MB!');
        }
        return isJPG && isLt2M;
      },
    httpRequest(file) {
        let fd = new FormData();
        fd.append('file', file.file);
        putFile(fd, { timeout: 120000 })
          .then((res) => {
           this.form.imgUrl = res.data.link
          })
          .catch((err) => {});
      },
   
    
   
    async initData() {
      getDictionary('park_area_right_type').then((res) => {
        this.parkAreaRightTypeList = res.data;
      });
      getParkList().then((res) => {
        this.spaceIdList = res.data;
      });
      if (this.model == 'add') {
        console.log(' this.spaceId', this.spaceId)
        this.form.parkingLotId = this.spaceId;
        this.form.blackType = Number(this.type);
        nodeTreeByParentId(this.form.parkingLotId).then((res) => {
          this.regionList = res.data;
        });
      } else {
        getDetail({ id: this.row.id }).then((res) => {
          this.form = res.data;
          this.form.parkAreaRightType += '';
        
          
          nodeTreeByParentId(this.form.parkingLotId).then((res) => {
            this.regionList = res.data;
          });
        });
      }

      console.log(this.form);
      //获取区域
    },
    saveRecord() {
        console.log(this.imageUrl)
      this.$refs['formRef'].validate((valid) => {
        if (valid) {
          
          let obj = Object.assign({}, this.form);
          
          if(Array.isArray(obj.regionIds)){
            obj.regionIds = obj.regionIds.join(',');
          }
          console.log(this.form.fileUrlList);
          if (this.model == 'add') {
            add(obj).then((res) => {
              this.$message.success('新增成功');
              this.$emit('success');
            });
          } else {
            update(obj).then((res) => {
              this.$message.success('修改成功');
              this.$emit('success');
            });
          }
        }
      });
    },
    cancleRecord() {
      this.$emit('cancle');
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-col-12 {
    height: 54px;
}
.video-preview {
  width: 100vw;
  height: calc(100vh - 30px);
  display: flex;
  justify-content: center;
}
::v-deep .video-preview-dialog {
  background-color: rgba(0, 0, 0, 0.5) !important;
  div {
    padding: 0 !important;
  }
  .el-dialog__header {
    height: 30px;
  }
}
</style>
